import axios from 'axios'
import { Message } from 'element-ui'
import router from '@/router'
import store from '@/store'
import { baseUrl } from '@/env'

const service = axios.create({
  timeout: 60000,
  baseURL: baseUrl
})

const err = error => {
  if (error.response) {
    if (error.response.status === 401) {
      store.commit('setPath', '')
      store.commit('setMenus', [])
      store.commit('setToken', { token: '', tokenExpires: '' })
      router.push('/login')
    } else if (error.response.status === 500) {
      Message.error(error.response.data.msg)
    } else if (error.response.status === 208) {
      Message.error(error.response.data.msg)
    } else {
      return error.response.data
    }
  }
  return Promise.reject(error)
}

service.interceptors.request.use(config => {
  config.headers['Content-Type'] = 'application/json'
  // 无校验码头部用：Authorization Basic dGVzdDp0ZXN0
  // 有校验码头部用：Authorization Basic cGlnOnBpZw
  if (config.url === '/auth/oauth/token' || (new Date().getTime() > store.state.TOKEN_EXPIRES)) {
    config.headers['Authorization'] = 'Basic dGVzdDp0ZXN0'
  } else {
    if (store.state.TOKEN) {
      config.headers['Authorization'] = 'Bearer ' + store.state.TOKEN
    }
  }

  return config
}, err)

service.interceptors.response.use(response => {
  return response.data
}, err)

export { service as axios }
